export const FORM_NAME: string = 'WITHDRAWALS_TOOLS';
export const TOKEN_FORM: string = 'TOKEN_FORM';

export const TOOLS_REGISTERS = {
  token: 'token',
  isUnavailable: 'isUnavailable',
  isReady: 'isReady',
  withdrawalResponse: 'withdrawalResponse',
};

export const gridStyles = {
  columns: '25% auto',
  columnGap: '5px',
  rowGap: '7px',
  minRowHeight: '45px',
};
